<template>
  <p-container>
    <p-card>
      <p-row column>
        <p-col>
          <h2 class="mb-4">
            {{ $t('core.page.user.page.newEntry') }}
          </h2>
          <p-text-field v-model="newUserModel.userName" :label="$t('core.page.registration.label.userName')" class="ix-7" required></p-text-field>
          <p-text-field v-model="newUserModel.email" type="email" :label="$t('core.page.registration.label.userEmail')" class="ix-7" required></p-text-field>
          <p-text-field
            v-model="newUserModel.password"
            type="password"
            :errors="passwordValidationMessage"
            :label="$t('core.page.registration.label.userPassword')"
            class="ix-7"
            required
          ></p-text-field>
          <p-checkbox v-model="newUserModel.isGdprConsentAccepted" :label="$t('core.page.user.page.userConsentsToGdpr')" class="ix-7"></p-checkbox>
        </p-col>
        <p-row xs12>
          <p-row column>
            <div><p-request-alert v-model="linkError"></p-request-alert></div>
            <p-alert v-model="passwordValidationMessage" class="mt-4" :dismissable="false" type="error">
              {{ passwordValidationMessage }}
            </p-alert>
            <div>
              <p-button @click="createUser">
                {{ $t('core.page.user.action.createUser') }}
              </p-button>
            </div>
          </p-row>
        </p-row>
      </p-row>
    </p-card>
  </p-container>
</template>
<script lang="ts">
  import Vue from 'vue';
  import UserRegisterRequestViewModel from '../../../services/v1/viewModel/resource/UserRegisterRequestViewModel';

  export default Vue.extend({
    auth: true,
    role: ['admin', 'hostadmin'],
    layout: 'layout-hostadmin',
    data: () => ({
      passwordValidationMessage: undefined as string | undefined,
      newUserModel: new UserRegisterRequestViewModel(),
      linkError: undefined as string | undefined,
    }),
    methods: {
      async createUser() {
        this.passwordValidationMessage = undefined;
        const minLength = this.$config.values['auth-min-password-length'] ?? 0;
        if (!this.newUserModel?.password || this.newUserModel?.password?.length < minLength) {
          this.passwordValidationMessage = this.$t('core.validation.minLength', minLength);
          return;
        }
        // A hostadmin does not need to verify
        // Just show clear text and keep it simple
        this.newUserModel.passwordRepeat = this.newUserModel.password;
        this.$service.api.core.users.registerHostadmin(this.newUserModel)
          .then((id: any) => {
            Vue.$router.replace(`/_admin/users/${id}`);
          })
          .catch((error: any) => {
            this.linkError = error;
          });
      },
    },
  });
</script>
